export const COOKIE_CONSENT_KEY = 'tq_cookie_consent';

export const COOKIE_CONSENT_VALUES = {
  accepted: 'accepted',
  rejected: 'rejected',
};

const canUseBrowser = () => typeof window !== 'undefined';

const isValidCookieConsent = (value) =>
  value === COOKIE_CONSENT_VALUES.accepted || value === COOKIE_CONSENT_VALUES.rejected;

export const getStoredCookieConsent = () => {
  if (!canUseBrowser()) return null;

  const value = window.localStorage.getItem(COOKIE_CONSENT_KEY);
  return isValidCookieConsent(value) ? value : null;
};

export const setStoredCookieConsent = (value) => {
  if (!canUseBrowser()) return;

  if (isValidCookieConsent(value)) {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, value);
    return;
  }

  window.localStorage.removeItem(COOKIE_CONSENT_KEY);
};

export const hasTrackingConsent = () =>
  getStoredCookieConsent() === COOKIE_CONSENT_VALUES.accepted;
